module.exports = __webpack_public_path__ + "img/s16.7b9fe98.png";